// @vendors
import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";

// @components
import { RequestDetailsProfessional } from "../../../pages/asCompany/proposal/components/RequestDetailsProfessional";
import { ProposalForm } from "../../../pages/asCompany/proposal/components/ProposalForm";
import RequestList from "../../../pages/asCompany/proposal/components/RequestList";

// @types
import { ServiceRequest } from "../../../types/request.types";

// @services
import proposalService from "../../../services/proposal.service";

// @store
import { useSpinnerStore } from "../../../store/useSpinnerStore";

export const ProposalsPage: React.FC = () => {
  const { t } = useTranslation();
  const { openSpinner } = useSpinnerStore();
  const [selectedRequest, setSelectedRequest] = useState<ServiceRequest | null>(null);
  const [image, setImage] = useState<Blob | null>(null);

  const handleRequestSelect = (request: ServiceRequest) => {
    setImage(null);
    setSelectedRequest(request);
    if (request?.images.length) getImage(request?.images[0]?.serviceRequestImageId);
  };

  const handleResetRequestSelect = () => {
    setImage(null);
    setSelectedRequest(null);
  };

  const getImage = async (id: string) => {
    if (!id) return;
    openSpinner(true);
    try {
      const response = await proposalService.downloadImageService(id ?? '');
      setImage(response);
      openSpinner(false);
    } catch (error) {
      openSpinner(false);
      toast.error(t("error.callList"))
    }
  }

  return (
    <div className="flex flex-col px-8 h-[100vh] overflow-auto xl:overflow-hidden">
      <h1 className="text-[14px] font-medium mb-4 dark:text-dark-cText">
        {t("professional.request.titlePage")}
      </h1>
      <div className="flex flex-col xl:flex-row gap-4">
        <RequestList onSelectRequest={handleRequestSelect} />

        <RequestDetailsProfessional
          selectedRequest={selectedRequest}
          image={image}
        />

        <ProposalForm
          selectedRequest={selectedRequest}
          handleResetRequestSelect={handleResetRequestSelect}
        />
      </div>
    </div>
  );
};
